import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { CurrencyConversionRatePropTypes } from '../../shared/propTypes/currencyConversionRate';
import { requiredWhenPresent } from '../../shared/propTypes';
import {
  hideCurrencyConversionRateModalForRemove,
  removeCurrencyConversionRate,
} from './store/actions';
import Modal from '../../shared/modals/modal.component';
import { isRemovingInProgressSelector } from './store/selectors';


const RemoveCurrencyConversionRateModal = ({
  isRemovingInProgress,
  hide,
  entityToRemove,
  removeCurrencyConversionRate,
  isVisible,
  rowIndex,
}) => {
  function remove() {
    removeCurrencyConversionRate(entityToRemove, { rowIndex });
  }

  return (
    <Modal
      className="delete-currency-conversion-rate-modal"
      dismissText="Cancel"
      isSubmitting={isRemovingInProgress}
      submitText="Yes"
      title="Delete Currency Conversion Rate"
      closeAction={hide}
      dismissAction={hide}
      submitAction={remove} // eslint-disable-line react/jsx-no-bind
      isVisible={isVisible}
    >
      {
        entityToRemove
          ? (
            <div>
              Are you sure you want to delete:<br/><br/>
              From currency: {entityToRemove.fromCurrency}<br/>
              To currency: {entityToRemove.toCurrency}
            </div>
          )
          : null
      }
    </Modal>
  );
};

RemoveCurrencyConversionRateModal.propTypes = {
  entityToRemove: requiredWhenPresent(['isVisible'], CurrencyConversionRatePropTypes),
  hide: PropTypes.func.isRequired,
  removeCurrencyConversionRate: PropTypes.func.isRequired,
  isRemovingInProgress: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool,
  rowIndex: requiredWhenPresent(['isVisible'], PropTypes.number),
};

const mapStateToProps = state => ({
  isRemovingInProgress: isRemovingInProgressSelector(state),
});

export default connect(
  mapStateToProps,
  {
    hide: hideCurrencyConversionRateModalForRemove,
    removeCurrencyConversionRate,
  }
)(RemoveCurrencyConversionRateModal);
